import { merge } from 'lodash';

import { Injectable } from '@angular/core';

import { ISnListQueryParameters } from '@lib/api';
import { SnTeam } from '@lib/api/entities';
import { SnTeamsAPI } from '@lib/api/services';
import { ISnCheckboxFormFieldConfig } from '@lib/form/checkbox';
import { ISnColorPickerFormFieldConfig } from '@lib/form/color-picker';
import { ISnHttpSelectFormFieldConfig } from '@lib/form/http-select';
import { ISnInputFormFieldConfig } from '@lib/form/input';
import { t } from '@lib/translation';

@Injectable({ providedIn: 'root' })
export class SnTeamFieldsGeneratorService {
  constructor(private readonly _teamsService: SnTeamsAPI) {}

  public getTeamSelectField(
    fieldConfig?: Partial<ISnHttpSelectFormFieldConfig<SnTeam>>,
  ): ISnHttpSelectFormFieldConfig<SnTeam> {
    const baseFieldConfig: ISnHttpSelectFormFieldConfig<SnTeam> = {
      key: 'team',
      type: 'http-select',
      templateOptions: {
        label: t('common.team'),
        valueProp: 'id',
        labelProp: 'name',
        infinityScroll: true,
        fetchDataFn: (params: ISnListQueryParameters) => this._teamsService.getTeamList(params),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getNameField(fieldConfig?: Partial<ISnInputFormFieldConfig>): ISnInputFormFieldConfig {
    const baseFieldConfig: ISnInputFormFieldConfig = {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: t('common.name'),
        placeholder: t('common.enterName'),
        maxLength: 24,
      },
      validation: {
        messages: {
          unique: t('common.validation.unique'),
        },
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getColorField(
    fieldConfig?: Partial<ISnColorPickerFormFieldConfig>,
  ): ISnColorPickerFormFieldConfig {
    const baseFieldConfig: ISnColorPickerFormFieldConfig = {
      key: 'color',
      type: 'color-picker',
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getIsPrivateField(
    fieldConfig?: Partial<ISnCheckboxFormFieldConfig>,
  ): ISnCheckboxFormFieldConfig {
    const baseFieldConfig: ISnCheckboxFormFieldConfig = {
      key: 'isPrivate',
      type: 'checkbox',
      templateOptions: {
        label: t('users.teams.fieldIsPrivate'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }
}
